// components/PrivateRoute.js
import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import MyContext from "MyContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(MyContext);
  const isAuthenticated = user && Object.keys(user).length > 0;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoute;
